import styled, { css } from 'styled-components';

import { getThemeColor } from '@utils/styled';

import Typography from '@common/components/Typography';
import { Chevron } from '@common/components/Icons';

export const Wrapper = styled.a`
  position: relative;
  display: block;
  border-bottom: 1px solid ${getThemeColor('bluegrey.90')};
  ${({ theme }) => theme.getFluidSpacing('padding-top', 'scale', 6)};
  padding-right: ${({ withSizes }) => (withSizes ? '0' : '2.5rem')};
  color: inherit;

  &:hover {
    text-decoration: none;
  }
`;

export const CityWrapper = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: center;
`;

export const ChevronIcon = styled(Chevron).attrs({
  width: 20,
  height: 20,
})`
  position: absolute;
  top: 50%;
  right: 0;
  fill: ${getThemeColor('bluegrey.70')};
  transform: rotate(180deg) translateY(50%);
`;

export const Title = styled(Typography).attrs({
  variant: 'paragraph1',
  customAs: 'h5',
})`
  margin: 0;
  font-weight: 700;
`;

export const SubTitle = styled(Typography).attrs({
  variant: 'body2',
})`
  margin-bottom: 0.3rem;
`;

export const TitlesWrapper = styled.div`
  ${({ withSizes }) =>
    withSizes &&
    css`
      position: relative;
      padding-right: 2.5rem;
    `}
`;

export const DistanceValue = styled(Typography).attrs({
  variant: 'body4',
})`
  margin: 0;
  color: ${getThemeColor('bluegrey.60')};
`;
